<div id="approve-investor-company-modal" class="modal-body text-center">
  <p id="approve-investor-company-title-text" class="title"><strong>APPROVE</strong></p>
  <p id="approve-investor-company-content-tect">APPROVE <strong>{{newInvestorCompany.companyName}}</strong> AS A NEW COMPANY?</p>
  <button id="approve-investor-company-cancel-button" type="button" class="btn btn-secondary mt-1" (click)="cancel()">CANCEL</button>
  <button id="approve-investor-company-approve-button" type="button" class="btn btn-primary ml-2 mt-1" (click)="approve()">APPROVE</button>
</div>
